import { Injectable } from '@angular/core';
import { SchedulerAuthService } from '../../../common/scheduler/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SchedulerStageAuthService extends SchedulerAuthService {
  validateStage(): boolean {
    return true;
  }

  public hasAllowedRoles(roles: string[]): boolean {
    return this.lookForRolesNeeded(roles);
  }
}
